class DeliveryTime extends HTMLElement {
  constructor() {
    super();

    this.formatString = this.getAttribute("data-frm-day");
    this.excludedDays = (this.getAttribute("data-exclude-day") || "")
      .replace(/ /g, "")
      .split(",")
      .filter(Boolean);

    this.numbDateStart = parseInt(this.getAttribute("data-estimate-start"), 10) || 0;
    this.numbDateEnd = parseInt(this.getAttribute("data-estimate-end"), 10) || 0;
    this.targetTime = this.getAttribute("data-time") || "16:00:00";

    this.hr = this.querySelector(".productView-dlvr__remaining-hr");
    this.mins = this.querySelector(".productView-dlvr__remaining-mins");

    this.iso_code = document.documentElement.lang || "it-IT";
    this.locale = this.getLocale(this.iso_code);

    this.checkExclude = this.checkAllExcludeDays(this.excludedDays);
    if (this.checkExclude) return;

    this.productDeliveryTime();

    const countdown = this.countdownToTime(this.targetTime);
    if (this.hr) this.hr.textContent = countdown.hours;
    if (this.mins) this.mins.textContent = countdown.minutes;

    this.style.display = "block";

    setInterval(() => {
      const countdown = this.countdownToTime(this.targetTime);
      if (this.hr) this.hr.textContent = countdown.hours;
      if (this.mins) this.mins.textContent = countdown.minutes;
    }, 1000);
  }

  getLocale(lang) {
    if (!lang) return "it-IT";

    const normalized = lang.toLowerCase();

    if (normalized === "it" || normalized.startsWith("it-")) {
      return "it-IT";
    }

    return lang;
  }

  checkAllExcludeDays(excludedDays) {
    const now = new Date();
    const deliveryDateTime = new Date(now);

    for (let day of excludedDays) {
      const dayIndex = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].indexOf(day);
      if (deliveryDateTime.getDay() === dayIndex) return true;
    }

    return false;
  }

  productDeliveryTime() {
    const orderDlvr = document.querySelectorAll("[data-delivery-time]");
    if (orderDlvr.length === 0) return;

    const startDay = this.excludeDays(this.excludedDays, this.numbDateStart);
    const endDay = this.excludeDays(this.excludedDays, this.numbDateEnd);

    const formattedStartDate = this.formatDate(startDay, this.formatString);
    const formattedEndDate = this.formatDate(endDay, this.formatString);

    orderDlvr.forEach((el) => {
      const startEl = el.querySelector("[data-start-delivery]");
      const endEl = el.querySelector("[data-end-delivery]");

      if (startEl) startEl.textContent = formattedStartDate;
      if (endEl) endEl.textContent = formattedEndDate;
    });
  }

  formatDate(dateInput, formatString) {
    const date = new Date(dateInput);

    const dayOfWeek = date.toLocaleDateString(this.locale, { weekday: "long" });
    const dayOfMonth = date.toLocaleDateString(this.locale, { day: "2-digit" });
    const monthShort = date.toLocaleDateString(this.locale, { month: "short" }).replace(".", "");
    const monthLong = date.toLocaleDateString(this.locale, { month: "long" });
    const monthNumber = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.toLocaleDateString(this.locale, { year: "numeric" });

    let formattedDate = formatString;

    formattedDate = formattedDate.replace("YYYY", year);
    formattedDate = formattedDate.replace("MMMM", monthLong);
    formattedDate = formattedDate.replace("MMM", monthShort);
    formattedDate = formattedDate.replace("MM", monthNumber);
    formattedDate = formattedDate.replace("DD", dayOfMonth);
    formattedDate = formattedDate.replace("d", dayOfWeek);

    return this.capitalizeItalian(formattedDate);
  }

  capitalizeItalian(value) {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  excludeDays(excludedDays, dataRange) {
    const now = new Date();
    const deliveryDateTime = new Date(now);

    let daysToAdd = parseInt(dataRange, 10) || 0;

    while (daysToAdd > 0) {
      deliveryDateTime.setDate(deliveryDateTime.getDate() + 1);

      const currentDayIndex = deliveryDateTime.getDay();
      const currentDayKey = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][currentDayIndex];

      if (!excludedDays.includes(currentDayKey)) {
        daysToAdd--;
      }
    }

    while (excludedDays.includes(["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][deliveryDateTime.getDay()])) {
      deliveryDateTime.setDate(deliveryDateTime.getDate() + 1);
    }

    return deliveryDateTime;
  }

  countdownToTime(targetTime) {
    const currentTime = new Date();
    const targetTimeString = `${currentTime.toDateString()} ${targetTime}`;
    const targetDateTime = new Date(targetTimeString);

    if (targetDateTime < currentTime) {
      targetDateTime.setDate(targetDateTime.getDate() + 1);
    }

    const remainingTime = targetDateTime - currentTime;

    const hours = Math.floor(remainingTime / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

    return { hours, minutes };
  }
}

customElements.define("delivery-time", DeliveryTime);